'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateDomain = exports.getCompanyName = exports.getDomain = exports.getLastName = exports.getFirstName = exports.getPassword = exports.getEmail = exports.getUserInfo = undefined;

var _deriveDevelopersdomainFromUser = require('../utils/deriveDevelopersdomainFromUser');

var _deriveDevelopersdomainFromUser2 = _interopRequireDefault(_deriveDevelopersdomainFromUser);

var _isFunnel = require('../utils/isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUserInfo = exports.getUserInfo = function getUserInfo(state) {
  return state.userInfo;
};
var getEmail = exports.getEmail = function getEmail(state) {
  return getUserInfo(state).get('email');
};
var getPassword = exports.getPassword = function getPassword(state) {
  return getUserInfo(state).get('password');
};
var getFirstName = exports.getFirstName = function getFirstName(state) {
  return getUserInfo(state).get('firstName');
};
var getLastName = exports.getLastName = function getLastName(state) {
  return getUserInfo(state).get('lastName');
};
var getDomain = exports.getDomain = function getDomain(state) {
  return getUserInfo(state).get('domain');
};
var getCompanyName = exports.getCompanyName = function getCompanyName(state) {
  return getUserInfo(state).get('companyName');
};
var calculateDomain = exports.calculateDomain = function calculateDomain(state) {
  var user = getUserInfo(state);
  if (_isFunnel2.default.developers() || _isFunnel2.default.contentHubDeveloper()) {
    return (0, _deriveDevelopersdomainFromUser2.default)(user);
  }
  return user.get('domain');
};